(() => {
  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const variants = JSON.parse(root.querySelector('[data-topper-catalog]').textContent);
    const config = JSON.parse(root.querySelector('[data-topper-config]').textContent);
    const size = root.querySelector('[data-topper-size]');
    const texture = root.querySelector('[data-topper-texture]');
    const length = root.querySelector('[data-topper-length]');
    const density = root.querySelector('[data-topper-density]');
    const price = root.querySelector('[data-topper-price]');
    const cta = root.querySelector('[data-topper-consult]');
    const baseUrl = cta.getAttribute('href');
    const money = new Intl.NumberFormat(config.locale, {style:'currency', currency:config.currency, currencyDisplay:'code'});
    function setOptions(select, values, suffix = '') {
      const previous = select.value;
      select.replaceChildren(...values.map(value => new Option(value + suffix, value)));
      if (values.includes(previous)) select.value = previous;
    }
    function update() {
      const sized = variants.filter(v => v.size === size.value);
      setOptions(texture, [...new Set(sized.map(v => v.texture))]);
      const textured = sized.filter(v => v.texture === texture.value);
      setOptions(length, [...new Set(textured.map(v => v.length))].sort((a,b) => Number(a)-Number(b)), ' ' + config.inch);
      const variant = textured.find(v => v.length === length.value);
      price.textContent = money.format(variant.price / 100);
      const url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('topper_size',variant.size);
      url.searchParams.set('topper_texture',variant.texture);
      url.searchParams.set('topper_length',variant.length);
      url.searchParams.set('topper_density',density.value);
      cta.href = url.pathname + url.search;
    }
    [size,texture,length,density].forEach(select => select.addEventListener('change',update));
    update();
  }
  document.querySelectorAll('[data-topper-options]').forEach(mount);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-topper-options]').forEach(mount));
})();
